import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function ProgramHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center">
      <div className="absolute inset-0">
        <img
          src="/images/Climate-Adaptation-Photo.jpg"
          alt="Climate Adaptation Finance"
          className="w-full h-full object-cover"
          style={{ imageRendering: 'crisp-edges' }}
        />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Climate Adaptation Finance Professional Certificate
          </h1>
          <p className="text-xl text-green-100 mb-8 max-w-2xl">
            A comprehensive program designed to build expertise in climate finance and drive sustainable development across Africa
          </p>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 max-w-2xl">
            <h2 className="text-white text-xl font-semibold mb-4">Current Status</h2>
            <p className="text-green-100 mb-4">
              The current cohort is ongoing. Details for the next cohort will be announced soon.
            </p>
            
            {/* Commented out since there is no register form or link yet */}
            {/* 
            <button className="inline-flex items-center px-8 py-3 bg-white text-green-900 rounded-full hover:bg-green-50 transition-colors">
              Register Interest for Next Cohort
              <ArrowRight className="ml-2 h-5 w-5" />
            </button> 
            */}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
